import * as React from 'react'

export const About = () => {
  return (
    <div className='AI__about'>
      <div className='AI__about__bg' />

      <div className='container'>
        <h2>
          <span>AI + Business</span> <span>= การเติบโต</span>
        </h2>
      </div>

      <div className='AI__about__content'>
        <div className='container'>
          <div>
            <p>
              ปัจจุบันเทคโนโลยีอย่าง AI (Artificial Intelligence
              หรือเทคโนโลยีปัญญาประดิษฐ์)
              เข้ามามีบทบาทสำคัญทั้งในโลกของธุรกิจและผู้บริโภคอย่างต่อเนื่อง
              และถูกคาดการณ์ว่าจะเป็น Game Changer ที่เปลี่ยนโลกธุรกิจไปตลอดกาล
              แต่มีธุรกิจในไทยเพียง 10% เท่านั้นที่มีการนำ AI มาใช้งาน
              (ข้อมูลจากสถาบันไอเอ็มซี)
            </p>
            <p>
              Data Wow
              จึงต้องการเติมเต็มช่องว่างดังกล่าวและช่วยให้คุณได้นำโซลูชัน AI
              ที่ออกแบบโดย Data Science Experts มาปรับใช้กับโจทย์ธุรกิจของคุณ
              ไม่ว่าจะเป็น การปรับปรุงประสิทธิภาพของการทำงาน
              หรือการสร้างประสบการณ์ที่ดีแก่ลูกค้า สำหรับเรา ลูกค้าคือ Partner
              ที่เราต้องการส่งมอบ Complete Customised AI Solutions
              ตั้งแต่ต้นจนจบเพื่อให้ตอบโจทย์แต่ละธุรกิจได้อย่างแท้จริง
              และเพิ่มประสิทธิภาพของธุรกิจอย่างยั่งยืน
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
